import axios from 'axios'
import config from '../helpers/config'
import store from '../src/store'

export default {
    getExperiences: () => getExperiences(),
    saveExperiences: () => saveExperiences()
}

const getExperiences = async (filter) => {
    const auxConfig = config.getConfig('get', '/experiences?filter[include]=locationDepartments&filter[include]=locationMunicipalities&filter[where][expStatusId]=1')
    const {data} = await axios(auxConfig)
    if (filter) {
        store.state.experiences = data
        store.state.allExperiences = data
    } else {
        const filterData = data.filter(a => a.publishStatus === 1)
        store.state.experiences = filterData
        store.state.allExperiences = filterData
    }
    let exp = store.state.allExperiences
    if (exp.length !== 0) {
        localStorage.setItem('exp', JSON.stringify(exp));
    }
}

const saveExperiences = async () => {
    const ids = store.state.experiencesSelected //store.state.experiences.filter(exp => exp.status).map(exp => exp.id)
    const dat = {
        ids
    }
    if (dat === undefined){
        return
    }
    const auxConfig = config.getConfig('post', '/scriptFunctions/generatePDFbyID', dat)
    const { data } = await axios(auxConfig)
    return  data
    //return config.urlApi + data
}
